import { Module } from "vuex";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { IApprovalSystemState } from "../types";
import { StoreState } from "@/store/type";

const approvalSystemModule: Module<IApprovalSystemState, StoreState> = {
  state,
  getters,
  mutations,
  actions,
};

export default approvalSystemModule;
